import { createFileRoute } from "@tanstack/react-router";

import SharedListPage from "@/features/public/pages/shared-list";

export const Route = createFileRoute("/(public)/_public/lists/$token")({
  component: () => {
    const { token } = Route.useParams();
    return <SharedListPage token={token} />;
  },
  errorComponent: ({ error }: { error: Error }) => (
    <div role="alert" className="p-6">
      <h1 className="font-display text-2xl text-brand">Could not load this list</h1>
      <pre className="mt-4 whitespace-pre-wrap text-[13px] text-muted-foreground">{error.message}</pre>
    </div>
  ),
});
